import { cn } from "@/lib/utils"

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        // Base styles
        "relative overflow-hidden rounded-md bg-muted",
        // Shimmer effect using pseudo-element
        "before:absolute before:inset-0",
        "before:-translate-x-full",
        "before:bg-gradient-to-r before:from-transparent before:via-foreground/5 before:to-transparent",
        "before:animate-[shimmer_2s_infinite]",
        // Dark mode adjustment
        "dark:before:via-foreground/10",
        className
      )}
      {...props}
    />
  )
}

export { Skeleton }
